// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LinkSave: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    color1 = "#e00b5a",
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 10 11" width={width} height={height}>
            <path
                fill="currentColor"
                d="M.714 1.679c0-.396.32-.715.715-.715v2.143c0 .395.319.714.714.714h4.286a.713.713 0 0 0 .714-.714V1.004c.1.036.194.094.27.17l1.663 1.663c.134.134.21.315.21.505v5.48c0 .395-.32.714-.715.714H1.43a.714.714 0 0 1-.715-.715zM2.143.964h4.286v2.143H2.143zM0 1.68v7.14c0 .788.64 1.429 1.429 1.429H8.57A1.43 1.43 0 0 0 10 8.821v-5.48c0-.379-.15-.743-.417-1.01L7.917.666A1.43 1.43 0 0 0 6.907.25H1.428A1.43 1.43 0 0 0 0 1.679m6.071 5a1.071 1.071 0 1 1-2.142 0 1.071 1.071 0 0 1 2.142 0M5 4.893a1.786 1.786 0 1 0 0 3.571 1.786 1.786 0 0 0 0-3.571"
            />
        </svg>
    );
};

export default React.memo(LinkSave);
